import React from "react";
import { Outlet } from "react-router-dom";

/**
 * V2 styled layout for authentication pages
 * Full-height centered layout with white card container
 */
export default function V2AuthLayout() {
  return (
    <div
      className="flex min-h-screen w-full items-center justify-center px-4 py-8"
      style={{
        background:
          "radial-gradient(ellipse at top left, rgba(232, 133, 74, 0.35) 0%, rgba(232, 133, 74, 0.08) 40%, transparent 65%), " +
          "radial-gradient(ellipse at bottom right, rgba(214, 107, 46, 0.3) 0%, rgba(214, 107, 46, 0.06) 40%, transparent 65%), " +
          "radial-gradient(ellipse at center, rgba(232, 133, 74, 0.05) 0%, transparent 70%), " +
          "#F8F9FA",
      }}
    >
      <div className="w-full max-w-[440px] rounded-[20px] bg-white p-8 shadow-lg">
        {/* Logo */}
        <div className="mb-6 flex justify-center">
          <img
            src="https://dvsdkst7yiljv.cloudfront.net/sit-logo.png"
            alt="Sports Impact Technology"
            className="h-24 w-auto"
          />
        </div>

        {/* Auth page content */}
        <Outlet />
      </div>
    </div>
  );
}
